import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/*  A futó tömeges ellenőrzés azonosítója itt marad meg, hogy egy oldalfrissítés
 *  után vissza tudjunk állni rá – különben a felhasználó azt hinné, elveszett. */
const MENET_KULCS = 'kreta-tomeges-menet';

/**
 *  KRÉTA ÓRAREND-ÖSSZEVETÉS — az új tanári kapun keresztül.
 *
 *  A régi KRÉTA-kapu köztes futtatóra épült: a hibái nem jutottak el a felhasználóig,
 *  és nem lehetett megmondani, mi miért nem ment át. Ez a képernyő ugyanazt a
 *  belépést használja, amivel a naplózás már élesben működik, és először csak
 *  ELLENŐRIZ: megmutatja, hol tér el a két rendszer órarendje.
 *
 *  Az áttöltés IRÁNYA nem szimmetrikus, és ezt ki is mondjuk: a KRÉTA felől át tudjuk
 *  venni az órákat, visszafelé viszont a tanári kapunak nincs órarend-író végpontja —
 *  ott a megtartott óra naplózása az, amit tenni lehet.
 */
@Component({
  selector: 'app-kreta-orarend',
  templateUrl: './kreta-orarend.component.html',
  styleUrls: ['./kreta-orarend.component.scss'],
})
export class KretaOrarendComponent implements OnInit, OnDestroy {
  intezmeny = '';
  tanarok: any[] = [];
  allomany = '';
  tol = '';
  ig = '';

  fut = false;
  atvesz = false;
  /*  Az átvétel eredménye KÜLÖN áll, és a képernyőn marad: ez mondja meg, mi íródott be
   *  és mi miért nem. Az összevetés újrafuttatása korábban elmosta. */
  atvetelEredmeny: any = null;
  /*  FELÜLÍRÁS. Alapból csak azt vesszük át, ami nálunk hiányzik vagy eltér, és a
   *  meglévő adatot nem bántjuk. Bekapcsolva a KRÉTA a mérvadó: az osztály/csoport
   *  párost és a termet is felülírjuk — az egyező órákat is beleértve, mert azoknál is
   *  hiányozhat a terem vagy a csoport. */
  felulir = false;
  /*  A HIÁNYZÓ TÖRZSADAT (tantárgy, csoport, terem, osztály) ALAPBÓL létrejön – a
   *  kimaradt óra drágább, mint egy utólag átnevezendő tétel (user, 2026-09-28: „ha nem
   *  talál valamit, ne csak kihagyja"). Egyenként kikapcsolható. Osztály csak egyértelmű
   *  osztálynévből („10/F") készül; a tanulóit az osztálykezelésben kell hozzárendelni. */
  tantargyLetrehoz = true;
  csoportLetrehoz = true;
  teremLetrehoz = true;
  osztalyLetrehoz = true;
  /*  A csoportok tagjai a KRÉTA-csoporttükörből (Admin → Csoporttagság a KRÉTÁ-ból). */
  tagsag = true;
  /*  Amiről a KRÉTA EGYÁLTALÁN nem tud: alapból nem nyúlunk hozzá, mert lehet, hogy csak
   *  nálunk van felvéve. Külön kérésre viszont törölhető. */
  torolIsmeretlen = false;
  tomegesAtvesz = false;
  tomegesAtvetelEredmeny: any = null;
  hiba = '';
  eredmeny: any = null;

  /*  TÖMEGES ELLENŐRZÉS. Egyesével végigmenni húsz kollégán annyit jelentett, hogy
   *  húszszor kellett kiválasztani a nevet, megvárni a KRÉTA-belépést, és fejben
   *  összegezni az eredményt. Itt egyszerre jelölhetők ki, és egy összesítő tábla
   *  mutatja, kinél van eltérés — onnan lehet belépni a részletekbe.
   *
   *  A MUNKA A KISZOLGÁLÓN, A HÁTTÉRBEN FUT. Ez a képernyő csak elindítja, és
   *  kétmásodpercenként megkérdezi, hol tart. Így látszik a haladás, meg lehet
   *  szakítani, és egy oldalfrissítés sem dobja el: a menet azonosítóját megjegyezzük,
   *  és visszatéréskor ráállunk. */
  tomegesKijelolt = new Set<string>();
  tomegesFut = false;
  tomegesMenet = '';
  tomegesEredmeny: any = null;
  private tomegesIdozito: any = null;

  tomegesValt(adid: string) {
    if (this.tomegesKijelolt.has(adid)) this.tomegesKijelolt.delete(adid);
    else this.tomegesKijelolt.add(adid);
  }
  tomegesMind() {
    /*  Csak az AKTÍV hozzáféréseket jelöljük ki: a kikapcsoltnál a belépés úgyis
     *  elbukna, és csak lassítaná a menetet. */
    const jelolheto = (this.tanarok || []).filter((t: any) => t.aktiv);
    const mind = jelolheto.length && jelolheto.every((t: any) => this.tomegesKijelolt.has(t.allomany));
    this.tomegesKijelolt.clear();
    if (!mind) for (const t of jelolheto) this.tomegesKijelolt.add(t.allomany);
  }

  async tomegesOsszevet() {
    const allomanyok = [...this.tomegesKijelolt];
    if (!allomanyok.length) { this.data.sendToast('Jelölj ki legalább egy kollégát.', 'warning'); return; }
    /*  A KRÉTA-belépés kollégánként külön történik és lassú – ezt előre megmondjuk,
     *  azzal együtt, hogy nem kell mellette ülni. */
    if (!confirm(`${allomanyok.length} kolléga ellenőrzése a(z) ${this.tol} – ${this.ig} időszakra.\n\n`
      + 'A KRÉTA-belépés kollégánként külön történik, ezért ez percekig tarthat. A futás a '
      + 'háttérben zajlik: a haladás itt látszik, közben elnavigálhatsz, és meg is szakíthatod.'
      + '\n\nFolytatod?')) return;

    this.tomegesFut = true;
    this.hiba = '';
    this.tomegesEredmeny = null;
    this.tomegesAtvetelEredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post(
        `/api/kreta-orarend/osszevetes-tomeges/${this.intezmenyPath}`,
        { allomanyok, tol: this.tol, ig: this.ig }));
      this.tomegesEredmeny = r;
      /*  Ha a kiszolgáló korlátja levágott kollégákat, azt KIMONDJUK: a néma eldobásból
       *  a felhasználó azt látta, hogy kijelölt hatvanat és negyven futott le. */
      if (r?.kimaradt?.length) {
        this.data.sendToast(`${r.kimaradt.length} kolléga nem indult el: egy menetben `
          + `legfeljebb ${r.korlat || '?'} fő ellenőrizhető. Őket egy következő menetben futtasd.`,
          'warning');
      }
      this.figyel(r.menet);
    } catch (e: any) {
      /*  Már fut egy menet ugyanennek a felhasználónak: ne indítsunk másodikat (a két
       *  KRÉTA-munkamenet kiütné egymást), hanem álljunk rá a futóra. */
      if (e?.status === 409 && e?.error?.menet) {
        this.data.sendToast(e.error.error, 'warning');
        this.figyel(e.error.menet);
        return;
      }
      this.hiba = e?.error?.error || 'A tömeges ellenőrzés nem indult el.';
      this.tomegesFut = false;
    }
  }

  /** Kétmásodpercenként megkérdezi, hol tart a menet. Egyszerre csak egy kérés van úton. */
  private figyel(menet: string) {
    this.tomegesMenet = menet;
    this.tomegesFut = true;
    try { localStorage.setItem(MENET_KULCS, menet); } catch (e) { /* mindegy */ }
    if (this.tomegesIdozito) { clearTimeout(this.tomegesIdozito); this.tomegesIdozito = null; }

    const kor = async () => {
      let a: any;
      try {
        a = await firstValueFrom(this.http.get(
          `/api/kreta-orarend/osszevetes-tomeges/allapot/${menet}`));
      } catch (e: any) {
        /*  A menet elveszett (lejárt, vagy a kiszolgáló újraindult) – ilyenkor MEGÁLLUNK.
         *  Tovább kérdezgetni percenként harmincszor csak a naplót töltené. */
        this.hiba = e?.error?.error || 'Az ellenőrzés állapota nem kérdezhető le.';
        this.tomegesElfelejt();
        return;
      }
      this.tomegesEredmeny = a;
      if (a.allapot === 'fut') { this.tomegesIdozito = setTimeout(kor, 2000); return; }
      this.tomegesLeall();
      if (a.allapot === 'hiba' && a.hiba) this.hiba = a.hiba;
    };
    kor();
  }

  /*  Csak a kérdezgetést állítjuk le. A menet AZONOSÍTÓJÁT MEGTARTJUK: az eredményből
   *  dolgozik az „Összes adat átvétele", és egy oldalfrissítés után is vissza kell
   *  találnunk hozzá — enélkül a hosszú ellenőrzés eredménye egy F5-re elveszett. */
  private tomegesLeall() {
    if (this.tomegesIdozito) { clearTimeout(this.tomegesIdozito); this.tomegesIdozito = null; }
    this.tomegesFut = false;
  }

  /** A menet végleg elveszett (lejárt, kiszolgáló-újraindulás): ne keressük tovább. */
  private tomegesElfelejt() {
    this.tomegesLeall();
    this.tomegesMenet = '';
    try { localStorage.removeItem(MENET_KULCS); } catch (e) { /* mindegy */ }
  }

  async tomegesMegszakitas() {
    if (!this.tomegesMenet) return;
    if (!confirm('Megszakítod az ellenőrzést? Az éppen folyamatban lévő kolléga még '
      + 'befejeződik, az addigi eredmény megmarad.')) return;
    try {
      this.tomegesEredmeny = await firstValueFrom(this.http.post(
        `/api/kreta-orarend/osszevetes-tomeges/megszakit/${this.tomegesMenet}`, {}));
      this.data.sendToast('Az ellenőrzés a jelenlegi kolléga után leáll.', 'warning');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A megszakítás nem sikerült.', 'error');
    }
  }

  /** Hány százaléknál tartunk (0–1) – az ion-progress-bar ezt várja. */
  get tomegesArany(): number {
    const e = this.tomegesEredmeny;
    return e?.osszes ? Math.min(1, (e.kesz || 0) / e.osszes) : 0;
  }

  /** Emberi időtartam: „4 p 20 mp". */
  ido(ms: number): string {
    const mp = Math.max(0, Math.round((ms || 0) / 1000));
    const p = Math.floor(mp / 60);
    return p ? `${p} p ${mp % 60} mp` : `${mp} mp`;
  }

  /**
   *  Egy kolléga sorára kattintva a részletes nézetbe lépünk – a menetben ELTETT
   *  eredményből, tehát új KRÉTA-belépés nélkül.
   */
  async tomegesMegnyit(sor: any) {
    const menet = this.tomegesEredmeny?.menet || this.tomegesMenet;
    if (!menet) return;
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/kreta-orarend/osszevetes-tomeges/reszlet/${menet}/${encodeURIComponent(sor.allomany)}`));
      this.allomany = sor.allomany;
      this.eredmeny = r;
      this.kijelolt.clear();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { /* mindegy */ }
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A részletek nem tölthetők be.', 'error');
    }
  }

  tanarNev(allomany: string): string {
    const t = (this.tanarok || []).find((x: any) => x.allomany === allomany);
    return t?.nev || allomany;
  }

  /** Kijelölt tételek (kulcs szerint) a KRÉTA → Sulinform átvételhez. */
  kijelolt = new Set<string>();
  /** Melyik állapotokat mutatjuk. Alapból az eltéréseket: azért nyitja meg az ember. */
  szurok: Record<string, boolean> = {
    elter: true, csak_kreta: true, csak_sulinform: true, egyezik: false,
    athelyezve: true, felesleges: true,
  };

  /*  A korábbi áthelyezésekből ott maradt, feleslegessé vált órák takarítása.
   *  Alapból be: a duplikátum a tanuló órarendjében és a naplóban is látszik. */
  feleslegesTorles = true;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    // Alapértelmezett időszak: a mai héttől két hétre előre — ennyit lát át az ember.
    const ma = new Date();
    const plusz = new Date(ma.getTime() + 14 * 24 * 3600 * 1000);
    this.tol = ma.toISOString().slice(0, 10);
    this.ig = plusz.toISOString().slice(0, 10);
    await this.tanarokBetoltese();
    /*  Maradt ellenőrzési menet? Álljunk vissza rá – akár fut még, akár már kész.
     *  A befejezett menet eredményéből dolgozik az „Összes adat átvétele", ezért egy
     *  oldalfrissítés nem dobhatja el. */
    let menet = '';
    try { menet = localStorage.getItem(MENET_KULCS) || ''; } catch (e) { /* mindegy */ }
    if (menet) this.figyel(menet);
  }

  ngOnDestroy() {
    /*  Csak a kérdezgetést állítjuk le – a menet a kiszolgálón fut tovább, és
     *  visszatéréskor újra felvesszük a fonalat. */
    if (this.tomegesIdozito) { clearTimeout(this.tomegesIdozito); this.tomegesIdozito = null; }
  }

  get intezmenyPath(): string { return encodeURI(this.intezmeny); }

  async tanarokBetoltese() {
    try {
      this.tanarok = await firstValueFrom(this.http.get<any[]>(
        `/api/kreta-orarend/tanarok/${this.intezmenyPath}`)) || [];
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A tanári hozzáférések listája nem tölthető be.';
    }
  }

  async osszevet() {
    if (!this.allomany) { this.data.sendToast('Válassz tanárt.', 'warning'); return; }
    this.fut = true;
    this.hiba = '';
    this.eredmeny = null;
    this.atvetelEredmeny = null;
    this.kijelolt.clear();
    try {
      this.eredmeny = await firstValueFrom(this.http.post(
        `/api/kreta-orarend/osszevetes/${this.intezmenyPath}`,
        { allomany: this.allomany, tol: this.tol, ig: this.ig }));
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Az összevetés nem sikerült.';
    } finally {
      this.fut = false;
    }
  }

  get szurtTetelek(): any[] {
    return (this.eredmeny?.tetelek || []).filter((t: any) => this.szurok[t.allapot]);
  }

  /**
   *  Mit lehet átvenni: amit a KRÉTA tud és mi nem (vagy másképp), az ÁTHELYEZETT órát
   *  (ott a meglévő sor költözik, nem új keletkezik), és – ha a kapcsoló be van
   *  kapcsolva – a korábbi áthelyezésből ott maradt FELESLEGES sort, amit törlünk.
   */
  atvehetoE(t: any): boolean {
    if (t.allapot === 'felesleges') return this.feleslegesTorles;
    // Amiről a KRÉTA nem tud: csak akkor kezelhető (törölhető), ha kérték.
    if (t.allapot === 'csak_sulinform') return this.torolIsmeretlen;
    return t.allapot === 'csak_kreta' || t.allapot === 'elter' || t.allapot === 'athelyezve';
  }

  kijeloltE(t: any): boolean { return this.kijelolt.has(t.kulcs); }
  kijelolValt(t: any) {
    if (!this.atvehetoE(t)) return;
    if (this.kijelolt.has(t.kulcs)) this.kijelolt.delete(t.kulcs); else this.kijelolt.add(t.kulcs);
  }
  mindKijelol() {
    const lista = this.szurtTetelek.filter((t) => this.atvehetoE(t));
    const mind = lista.length && lista.every((t) => this.kijelolt.has(t.kulcs));
    for (const t of lista) { if (mind) this.kijelolt.delete(t.kulcs); else this.kijelolt.add(t.kulcs); }
  }

  /*  TANTÁRGY KÖTÉSE. Ha a KRÉTA más néven adja ugyanazt a tantárgyat, nem az órát kell
   *  átírni (azzal a tantárgyfelosztás és a tanmenet a régi tantárgyon maradna), hanem
   *  rögzíteni, hogy a KRÉTA-név a MI tantárgyunkat jelenti. Utána az összevetés és az
   *  átvétel is ehhez tartja magát. */
  kotesFut: string | null = null;
  kothetoE(t: any): boolean {
    return t?.allapot === 'elter' && (t.elteres || []).includes('tantárgy')
      && !!t.sajat?.tantargy_id && !!t.kreta?.tantargy;
  }
  async tantargyKotes(t: any) {
    if (!this.kothetoE(t)) return;
    if (!confirm(`A KRÉTA „${t.kreta.tantargy}” tantárgya nálunk a(z) „${t.sajat.tantargy}”?\n\n`
      + 'Rögzítjük a kötést: az összevetés egyezőnek veszi, és az átvétel az órákat ezen a '
      + 'tantárgyon hagyja. Tantárgyat nem hozunk létre, órát nem írunk át.')) return;
    this.kotesFut = t.kulcs;
    try {
      await firstValueFrom(this.http.post(`/api/kreta-orarend/tantargy-kotes/${this.intezmenyPath}`,
        { kreta_nev: t.kreta.tantargy, tantargy_id: t.sajat.tantargy_id, datum: t.datum }));
      //  Minden sor, amelyik ugyanezt a párt mutatja, egyezővé válik (nem csak a kattintott).
      const nev = String(t.kreta.tantargy).trim().toLowerCase();
      let db = 0;
      for (const x of (this.eredmeny?.tetelek || [])) {
        if (x.allapot !== 'elter' || String(x.kreta?.tantargy || '').trim().toLowerCase() !== nev
          || String(x.sajat?.tantargy_id) !== String(t.sajat.tantargy_id)) continue;
        x.elteres = (x.elteres || []).filter((e: string) => e !== 'tantárgy');
        if (!x.elteres.length) { x.allapot = 'egyezik'; this.kijelolt.delete(x.kulcs); }
        db++;
      }
      this.data.sendToast(`Kötve: „${t.kreta.tantargy}” = „${t.sajat.tantargy}” (${db} sor).`, 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A tantárgy kötése nem sikerült.', 'error');
    } finally {
      this.kotesFut = null;
    }
  }

  allapotSzoveg(a: string): string {
    return ({
      egyezik: 'egyezik',
      elter: 'eltér',
      athelyezve: 'áthelyezve',
      felesleges: 'feleslegessé vált',
      csak_kreta: 'csak a KRÉTA-ban',
      csak_sulinform: 'csak nálunk',
    } as any)[a] || a;
  }

  /**
   *  ÁTVÉTEL. `mind = true` esetén minden átvehető tétel megy, kijelölés nélkül.
   *
   *  Az eredményt KÜLÖN tartjuk és a képernyőn HAGYJUK. Korábban az átvétel után azonnal
   *  újraindult az összevetés, ami kinullázta az eredményt és a „mi maradt ki" listát —
   *  a felhasználó egy eltűnő buborékon kívül semmit nem látott abból, hogy mi történt,
   *  ráadásul közben újabb, perces KRÉTA-belépés indult.
   */
  async atvetel(mind = false) {
    const jeloltek = (this.eredmeny?.tetelek || [])
      .filter((t: any) => (mind ? this.atvehetoE(t) : this.kijelolt.has(t.kulcs))
        && (t.kreta || t.allapot === 'felesleges'));
    const tetelek = jeloltek.map((t: any) => ({
      datum: t.datum, ora: t.ora,
      /*  MINDEN adatot átadunk, amit a KRÉTA tudott: osztály/csoport, tantárgy, terem.
       *  A kiszolgáló oldja fel őket törzsadatra – kitalálni semmit nem talál ki. */
      osztaly: t.kreta?.osztaly, tantargy: t.kreta?.tantargy, terem: t.kreta?.terem,
      /*  Az áthelyezéshez és a takarításhoz a MEGLÉVŐ sor azonosítója is kell: abból
       *  tudja a kiszolgáló, hogy mozgatni vagy törölni kell, nem újat írni. */
      allapot: t.allapot, sajat_id: t.sajat?.id || null, honnan: t.honnan, parja: t.parja,
    }));
    if (!tetelek.length) {
      this.data.sendToast(mind ? 'Nincs átvehető óra.' : 'Nincs kijelölt átvehető tétel.', 'warning');
      return;
    }
    if (!confirm(`${tetelek.length} óra átvétele a KRÉTA-ból az órarendünkbe.\n\n`
      + (this.felulir
        ? 'FELÜLÍRÁSSAL: a meglévő órák osztálya/csoportja, tantárgya és terme a KRÉTA szerint lesz.'
        : 'A meglévő órákon csak azt töltjük ki, ami nálunk hiányzik.')
      + '\n\nFolytatod?')) return;

    this.atvesz = true;
    this.atvetelEredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post(
        `/api/kreta-orarend/atvesz/${this.intezmenyPath}`,
        { allomany: this.allomany, tetelek, felulir: this.felulir,
          tantargy_letrehoz: this.tantargyLetrehoz,
          csoport_letrehoz: this.csoportLetrehoz,
          terem_letrehoz: this.teremLetrehoz,
          osztaly_letrehoz: this.osztalyLetrehoz, tagsag: this.tagsag,
          torol_ismeretlen: this.torolIsmeretlen }));
      this.atvetelEredmeny = { ...r, kert: tetelek.length };
      this.data.sendToast(
        `${r?.felvett || 0} új óra, ${r?.frissitett || 0} frissítve, ${r?.athelyezett || 0} áthelyezve, `
        + `${r?.torolt || 0} törölve, ${r?.kihagyott || 0} kihagyva.`,
        (r?.felvett || r?.frissitett || r?.athelyezett || r?.torolt) ? 'success' : 'warning');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átvétel nem sikerült.', 'error');
    } finally {
      this.atvesz = false;
    }
  }

  /** Újraellenőrzés az átvétel után – KÜLÖN kattintásra, mert újabb KRÉTA-belépés. */
  async ujraEllenoriz() {
    this.atvetelEredmeny = null;
    await this.osszevet();
  }

  /**
   *  ÖSSZES ADAT ÁTVÉTELE — a menet MINDEN kollégájára, egyben.
   *
   *  A kiszolgáló a menetben eltett eredményből dolgozik, ezért nem kell újra belépni a
   *  KRÉTÁ-ba: a hosszú ellenőrzés után egyetlen kattintás az egész.
   */
  async tomegesAtvetel() {
    const menet = this.tomegesEredmeny?.menet || this.tomegesMenet;
    if (!menet) return;
    const o = this.tomegesEredmeny?.osszeg || {};
    const db = (o.csak_kretaban || 0) + (o.elter || 0) + (o.athelyezve || 0)
      + (this.felulir ? (o.egyezo || 0) : 0)
      + (this.feleslegesTorles ? (o.felesleges || 0) : 0)
      + (this.torolIsmeretlen ? (o.csak_nalunk || 0) : 0);
    if (!db) { this.data.sendToast('Nincs átvehető óra ebben a menetben.', 'warning'); return; }
    if (!confirm(`${db} óra átvétele a KRÉTA-ból, ${this.tomegesEredmeny?.tanarok?.length || 0} kolléga `
      + 'órarendjébe.\n\n'
      + (this.felulir
        ? 'FELÜLÍRÁSSAL: az egyező órákat is átvesszük, és a meglévő osztály/csoport, tantárgy '
          + 'és terem a KRÉTA szerint lesz.'
        : 'Csak azt vesszük át, amit a KRÉTA tud és mi nem (vagy másképp).')
      + (this.feleslegesTorles
        ? ' Az áthelyezett órák a meglévő sor MOZGATÁSÁVAL kerülnek a helyükre, a korábbi '
          + 'áthelyezésekből ott maradt felesleges sorokat pedig töröljük.'
        : ' Az áthelyezett órák a meglévő sor mozgatásával kerülnek a helyükre.')
      + ' A többi „csak nálunk" sorhoz egyik módban sem nyúlunk.\n\nFolytatod?')) return;

    this.tomegesAtvesz = true;
    this.tomegesAtvetelEredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post(
        `/api/kreta-orarend/atvesz-tomeges/${this.intezmenyPath}`,
        { menet, felulir: this.felulir, tantargy_letrehoz: this.tantargyLetrehoz,
          csoport_letrehoz: this.csoportLetrehoz, terem_letrehoz: this.teremLetrehoz,
          osztaly_letrehoz: this.osztalyLetrehoz, tagsag: this.tagsag,
          felesleges_torles: this.feleslegesTorles, torol_ismeretlen: this.torolIsmeretlen }));
      this.tomegesAtvetelEredmeny = r;
      this.data.sendToast(`${r?.osszeg?.felvett || 0} új óra, ${r?.osszeg?.frissitett || 0} frissítve, `
        + `${r?.osszeg?.kihagyott || 0} kihagyva.`,
        (r?.osszeg?.felvett || r?.osszeg?.frissitett) ? 'success' : 'warning');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A tömeges átvétel nem sikerült.', 'error');
    } finally {
      this.tomegesAtvesz = false;
    }
  }
}
